/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Sponsored_PlacementInputs */

const en_directory_detail_sponsored_placement = /** @type {(inputs: Directory_Detail_Sponsored_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sponsored placement`)
};

const zh_directory_detail_sponsored_placement = /** @type {(inputs: Directory_Detail_Sponsored_PlacementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赞助展示`)
};

/**
* | output |
* | --- |
* | "Sponsored placement" |
*
* @param {Directory_Detail_Sponsored_PlacementInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_sponsored_placement = /** @type {((inputs?: Directory_Detail_Sponsored_PlacementInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Sponsored_PlacementInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_sponsored_placement(inputs)
	return zh_directory_detail_sponsored_placement(inputs)
});
export { directory_detail_sponsored_placement as "directory.detail.sponsored_placement" }